export const ALL_SELLPOINTS = 'ALL_SELLPOINTS'
export const ALL_SELLPOINTS_SUCCESS = 'ALL_SELLPOINTS_SUCCESS'

export const ALL_PRODUCTS = 'ALL_PRODUCTS'
export const ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS'

export const PRODUCT_BY_ID = 'PRODUCT_BY_ID'
export const PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS'

export const VIEW_CART = 'VIEW_CART'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'

export const ERROR_MSG = 'ERROR_MSG'
export const SUCCESS_MSG = 'SUCCESS_MSG'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js